import { h } from '../utils'

export function fieldError() {
  const el = h('span', { class: 'vbzc-field-error' }) as HTMLSpanElement
  return { el }
}
